import React from "react"
import "./attributeProperties.scss"

const AttributePropertyItem = (props: { header: string; value: string | number | undefined }) => {
  if (props.value) {
    return (
      <>
        <td className="card-subtitle-1 align-top">{props.header}</td>
        <td className="attributeData" colSpan={props.header === "Description" || props.header === "Short name" || props.header === "Locational" ? 3 : 1}>
          {props.value}
        </td>
      </>
    )
  }
  return <></>
}

export default AttributePropertyItem
